import { createTrackerForCategory } from '@gonfalon/analytics/createTrackerForCategory';

export const trackIntegrationEvent = createTrackerForCategory('Integration');
